import WidgetModel from 'scoreboard/dashboards/widgets/widget-model'
import ChartTableView from 'scoreboard/dashboards/widgets/chart/chart-table-widget-view'

const ChartTableModel = WidgetModel.extend({

	defaults: {
		type: 'chart-table'
	},

	containerDefaults: {
		width: 480,
		height: 330
	},

	viewCls: ChartTableView,

	multiSettableProps: [ 'background', 'tablePadding', 'showSeriesColor', 'showSeriesLabel', 'showData' ]
})

export default ChartTableModel
ChartTableModel.__filename__ = 'dashboards/widgets/chart/config/chart-table-model.js'
